import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import './Patients.css';

function Prescriptions({ user }) {
    const [prescriptions, setPrescriptions] = useState([]);
    const [settings, setSettings] = useState({});
    const [patientsList, setPatientsList] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showModal, setShowModal] = useState(false);
    const [currentPrescription, setCurrentPrescription] = useState({ id: null, patient_id: '', medicines: '', notes: '' });
    const [medicineSearch, setMedicineSearch] = useState(''); // İlaç arama state'i
    const [selectedMedicineName, setSelectedMedicineName] = useState(''); // Seçilen/Yazılan İlaç Adı
    const [selectedDosage, setSelectedDosage] = useState(''); // Dozaj
    const [usageInstruction, setUsageInstruction] = useState(''); // Kullanım Talimatı

    // Sık kullanılan ilaçlar listesi
    const commonMedicines = [
        "Augmentin 1000mg",
        "Arveles 25mg",
        "Majezik 100mg",
        "Klorhex %0.2 Gargara",
        "Apranax Fort 550mg",
        "Largopen 1g",
        "Rovamycine 3 M.I.U",
        "Andorex Gargara",
        "Parol 500mg"
    ];

    useEffect(() => {
        fetchPrescriptions();
        fetchPatients();
        fetchSettings();
    }, []);

    const fetchSettings = () => {
        axios.get('./backend/get_settings.php')
            .then(res => {
                if (res.data) setSettings(res.data);
            })
            .catch(err => console.error(err));
    };

    const fetchPrescriptions = () => {
        axios.get('./backend/get_prescriptions.php')
            .then(res => {
                setPrescriptions(Array.isArray(res.data) ? res.data : []);
                setLoading(false);
            })
            .catch(err => {
                console.error(err);
                setLoading(false);
            });
    };

    const fetchPatients = () => {
        axios.get('./backend/get_patients.php')
            .then(res => {
                if (Array.isArray(res.data)) setPatientsList(res.data);
            })
            .catch(err => console.error(err));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const data = { ...currentPrescription, doctor_id: user ? user.id : 1 };
        axios.post('./backend/save_prescription.php', data)
            .then(res => {
                toast.success(res.data.message);
                setShowModal(false);
                fetchPrescriptions();
            })
            .catch(err => toast.error('İşlem başarısız.'));
    };

    const handleDelete = (id) => {
        if(window.confirm('Bu reçeteyi silmek istediğinize emin misiniz?')) {
            axios.post('./backend/delete_prescription.php', { id })
                .then(res => {
                    toast.success(res.data.message);
                    fetchPrescriptions();
                });
        }
    };

    const openModal = (prescription = { id: null, patient_id: '', medicines: '', notes: '' }) => {
        setCurrentPrescription(prescription);
        setShowModal(true);
    };

    const handleMedicineSelect = (e) => {
        const med = e.target.value;
        if (!med) return;
        setSelectedMedicineName(med);
        setSelectedDosage('2x1'); // Varsayılan dozaj
        // Seçimi sıfırla ki tekrar aynı ilacı seçebilelim
        e.target.value = "";
    };

    const addMedicineToList = () => {
        if (!selectedMedicineName) return;
        let fullMedicineString = `${selectedMedicineName}`;
        if (selectedDosage) fullMedicineString += ` - ${selectedDosage}`;
        if (usageInstruction) fullMedicineString += ` (${usageInstruction})`;

        setCurrentPrescription(prev => ({
            ...prev,
            medicines: prev.medicines ? prev.medicines + '\n' + fullMedicineString : fullMedicineString
        }));

        setSelectedMedicineName('');
        setSelectedDosage('');
        setUsageInstruction('');
    };

    const handlePrint = (prescription) => {
        const patient = patientsList.find(p => p.id == prescription.patient_id);
        const age = patient && patient.birth_date ? new Date().getFullYear() - new Date(patient.birth_date).getFullYear() : '';
        const genderText = patient && patient.gender ? (patient.gender === 'male' ? 'Erkek' : (patient.gender === 'female' ? 'Kadın' : 'Diğer')) : '';

        const printWindow = window.open('', '_blank');
        printWindow.document.write(`
            <html>
            <head>
                <title>Reçete Yazdır</title>
                <style>
                    body { font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; padding: 20px; color: #333; max-width: 800px; margin: 0 auto; }
                    .header { text-align: center; border-bottom: 2px solid #4e73df; padding-bottom: 10px; margin-bottom: 20px; }
                    .header h1 { margin: 0; color: #4e73df; font-size: 24px; }
                    .header p { margin: 5px 0; color: #666; font-size: 14px; }
                    .info-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 10px; margin-bottom: 20px; background: #f8f9fc; padding: 15px; border-radius: 10px; }
                    .info-item { font-size: 14px; }
                    .info-item strong { color: #4e73df; display: inline-block; width: 80px; }
                    .medicines-box { border: 1px solid #eaecf4; padding: 20px; border-radius: 10px; min-height: 200px; }
                    .medicines-box h3 { margin-top: 0; border-bottom: 1px solid #eaecf4; padding-bottom: 10px; color: #2c3e50; font-size: 18px; }
                    .medicine-item { margin-bottom: 15px; padding-left: 30px; position: relative; font-size: 16px; font-weight: 500; display: flex; align-items: center; }
                    .medicine-item:before { content: ''; position: absolute; left: 0; top: 2px; width: 16px; height: 16px; border: 2px solid #333; border-radius: 3px; }
                    .notes-box { margin-top: 20px; font-size: 14px; color: #666; font-style: italic; }
                    .footer { margin-top: 60px; display: flex; justify-content: flex-end; }
                    .signature-box { text-align: center; width: 200px; }
                    .signature-line { border-top: 1px solid #333; margin-top: 50px; margin-bottom: 10px; }
                    @media print {
                        body { padding: 0; }
                        .no-print { display: none; }
                    }
                </style>
            </head>
            <body>
                <div class="header">
                    ${settings.clinic_logo ? `<img src="${settings.clinic_logo}" alt="Logo" style="max-width: ${settings.clinic_logo_width || '150px'}; max-height: 80px; margin-bottom: 5px;">` : ''}
                    <h1>${settings.clinic_name || 'Diş Kliniği'}</h1>
                    <p>${settings.clinic_address || ''}</p>
                    <p>${settings.clinic_phone ? 'Tel: ' + settings.clinic_phone : ''} ${settings.clinic_website ? '| ' + settings.clinic_website : ''}</p>
                </div>
                
                <div class="info-grid">
                    <div class="info-item"><strong>Hasta:</strong> ${prescription.patient_name}</div>
                    <div class="info-item"><strong>Yaş/Cinsiyet:</strong> ${age} / ${genderText}</div>
                    <div class="info-item"><strong>Tarih:</strong> ${new Date(prescription.created_at).toLocaleDateString()}</div>
                    <div class="info-item"><strong>Doktor:</strong> ${prescription.doctor_name}</div>
                    <div class="info-item"><strong>Reçete No:</strong> #${prescription.id}</div>
                </div>

                <div class="medicines-box">
                    <h3>R/p (Reçete)</h3>
                    ${prescription.medicines.split('\n').map(med => med.trim() ? `<div class="medicine-item">${med}</div>` : '').join('')}
                    
                    ${prescription.notes ? `
                    <div class="notes-box">
                        <strong>Notlar:</strong> ${prescription.notes}
                    </div>` : ''}
                </div>

                <div class="footer">
                    <div class="signature-box">
                        <p><strong>${prescription.doctor_name}</strong></p>
                        <div class="signature-line"></div>
                        <p>Kaşe / İmza</p>
                    </div>
                </div>
                <div style="text-align: center; font-size: 10px; color: #999; margin-top: 30px; border-top: 1px solid #eee; padding-top: 10px;">
                    ${settings.prescription_footer || 'Bu belge elektronik ortamda oluşturulmuştur.'}
                </div>
                <script>window.onload = function() { window.print(); }</script>
            </body>
            </html>
        `);
        printWindow.document.close();
    };

    if (loading) return <div>Yükleniyor...</div>;

    return (
        <div className="patients-container">
            <div className="header-actions">
                <h2>Reçete Yönetimi</h2>
                <button className="add-btn" onClick={() => openModal()}>+ Yeni Reçete Yaz</button>
            </div>

            <table className="data-table">
                <thead>
                    <tr>
                        <th>ID</th>
                        <th>Hasta</th>
                        <th>Doktor</th>
                        <th>İlaçlar</th>
                        <th>Notlar</th>
                        <th>Tarih</th>
                        <th style={{textAlign: 'right'}}>İşlemler</th>
                    </tr>
                </thead>
                <tbody>
                    {prescriptions.map(p => (
                        <tr key={p.id}>
                            <td data-label="ID">{p.id}</td>
                            <td data-label="Hasta">{p.patient_name}</td>
                            <td data-label="Doktor">{p.doctor_name}</td>
                            <td data-label="İlaçlar" style={{whiteSpace: 'pre-wrap'}}>{p.medicines}</td>
                            <td data-label="Notlar">{p.notes}</td>
                            <td data-label="Tarih">{new Date(p.created_at).toLocaleDateString()}</td>
                            <td data-label="İşlemler">
                                <div className="action-buttons" style={{justifyContent: 'flex-end'}}>
                                    <button className="edit-btn" style={{background: '#36b9cc', marginRight: '5px', display: 'inline-flex', alignItems: 'center', justifyContent: 'center'}} onClick={() => handlePrint(p)} title="Yazdır">
                                        <img src="/uploads/iconpack/printer.svg" alt="Yazdır" style={{ width: '18px', height: '18px' }} />
                                    </button>
                                    <button className="edit-btn" onClick={() => openModal(p)}>Düzenle</button>
                                    <button className="delete-btn" onClick={() => handleDelete(p.id)}>Sil</button>
                                </div>
                            </td>
                        </tr>
                    ))}
                    {prescriptions.length === 0 && <tr><td colSpan="7" style={{textAlign:'center'}}>Kayıtlı reçete bulunamadı.</td></tr>}
                </tbody>
            </table>

            {showModal && (
                <div className="modal-overlay">
                    <div className="modal">
                        <div className="modal-header">
                            <h3>{currentPrescription.id ? 'Reçete Düzenle' : 'Yeni Reçete'}</h3>
                            <button className="close-modal-btn" onClick={() => setShowModal(false)}>✕</button>
                        </div>
                        <div className="modal-body">
                            <form id="prescriptionForm" onSubmit={handleSubmit}>
                                <div className="form-group">
                                    <label>Hasta Seçiniz</label>
                                    <select value={currentPrescription.patient_id} onChange={e => setCurrentPrescription({...currentPrescription, patient_id: e.target.value})} required style={{ width: '100%', padding: '12px', borderRadius: '10px', border: '2px solid #eaecf4' }}>
                                        <option value="">Seçiniz...</option>
                                        {patientsList.map(p => (
                                            <option key={p.id} value={p.id}>{p.full_name}</option>
                                        ))}
                                    </select>
                                </div>
                                <div className="form-group">
                                    <label>İlaç Ekle / Düzenle</label>
                                    <div style={{ background: '#f8f9fc', padding: '15px', borderRadius: '10px', border: '1px solid #eaecf4', marginBottom: '15px' }}>
                                        <div style={{ display: 'flex', gap: '10px', marginBottom: '10px' }}>
                                            <input 
                                                type="text" 
                                                placeholder="İlaç Ara..." 
                                                value={medicineSearch}
                                                onChange={(e) => setMedicineSearch(e.target.value)}
                                                style={{ flex: 1, padding: '8px', borderRadius: '8px', border: '1px solid #ddd' }}
                                            />
                                            <select onChange={handleMedicineSelect} style={{ flex: 1, padding: '8px', borderRadius: '8px', border: '1px solid #ddd' }}>
                                                <option value="">Listeden Seç...</option>
                                                {commonMedicines.filter(m => m.toLowerCase().includes(medicineSearch.toLowerCase())).map((med, index) => (
                                                    <option key={index} value={med}>{med}</option>
                                                ))}
                                            </select>
                                        </div>
                                        <div style={{ display: 'flex', gap: '10px', alignItems: 'flex-end' }}>
                                            <div style={{ flex: 2 }}>
                                                <label style={{fontSize: '0.8rem', marginBottom: '2px', display:'block'}}>İlaç Adı</label>
                                                <input type="text" value={selectedMedicineName} onChange={(e) => setSelectedMedicineName(e.target.value)} placeholder="İlaç adı girin..." style={{ width: '100%', padding: '8px', borderRadius: '8px', border: '1px solid #ddd' }} />
                                            </div>
                                            <div style={{ flex: 1 }}>
                                                <label style={{fontSize: '0.8rem', marginBottom: '2px', display:'block'}}>Dozaj</label>
                                                <input type="text" value={selectedDosage} onChange={(e) => setSelectedDosage(e.target.value)} placeholder="Örn: 2x1" style={{ width: '100%', padding: '8px', borderRadius: '8px', border: '1px solid #ddd' }} />
                                            </div>
                                            <div style={{ flex: 1 }}>
                                                <label style={{fontSize: '0.8rem', marginBottom: '2px', display:'block'}}>Talimat</label>
                                                <input type="text" value={usageInstruction} onChange={(e) => setUsageInstruction(e.target.value)} placeholder="Aç/Tok" style={{ width: '100%', padding: '8px', borderRadius: '8px', border: '1px solid #ddd' }} />
                                            </div>
                                            <button type="button" onClick={addMedicineToList} className="save-btn" style={{ padding: '8px 15px', height: '38px' }}>Ekle</button>
                                        </div>
                                    </div>
                                </div>
                                <div className="form-group">
                                    <label>İlaçlar (Her satıra bir ilaç)</label>
                                    <textarea value={currentPrescription.medicines} onChange={e => setCurrentPrescription({...currentPrescription, medicines: e.target.value})} required style={{ width: '100%', padding: '10px', borderRadius: '10px', border: '2px solid #eaecf4', minHeight: '100px' }} placeholder="Örn: Arveles 25mg 2x1..." />
                                </div>
                                <div className="form-group">
                                    <label>Notlar</label>
                                    <textarea value={currentPrescription.notes} onChange={e => setCurrentPrescription({...currentPrescription, notes: e.target.value})} style={{ width: '100%', padding: '10px', borderRadius: '10px', border: '2px solid #eaecf4' }} placeholder="Kullanım talimatları vb." />
                                </div>
                            </form>
                        </div>
                        <div className="modal-actions">
                            <button type="button" className="cancel-btn" onClick={() => setShowModal(false)}>İptal</button>
                            <button type="submit" form="prescriptionForm" className="save-btn">Kaydet</button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default Prescriptions;